import { render, staticRenderFns } from "./image-loader.vue?vue&type=template&id=5a27ce61&"
import script from "./image-loader.js?vue&type=script&lang=js&"
export * from "./image-loader.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports